import Vue from "vue"
import VueRouter from "vue-router"

// Routes
// Ciclo preexistente: auth/utils -> jwt/useJwt -> axios
// eslint-disable-next-line import/no-cycle
import {
  getHomeRouteForLoggedInUser,
  getUserData,
  isUserLoggedIn,
} from "@/auth/utils"
import { guestHomePath } from "@/auth/guestSession"
import { canNavigate } from "@/libs/acl/routeProtection"

import checkout from "./routes/checkout"
import home from "./routes/home"
import legal from "./routes/legal"
import pages from "./routes/pages"
import portal from "./routes/portal"

Vue.use(VueRouter)

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    { path: "/", redirect: { name: "home" } },
    ...pages,
    ...home,
    ...portal,
    ...checkout,
    ...legal,
    {
      path: "*",
      redirect: "error-404",
    },
  ],
})

router.beforeEach((to, _, next) => {
  const isLoggedIn = isUserLoggedIn()

  if (!canNavigate(to)) {
    // Redirect to login if not logged in
    if (!isLoggedIn) return next({ name: "auth-login" })

    /*
         * Un invitado del canal de integradores solo puede ver su pantalla de pago.
         * Mandarlo a "no autorizado" lo deja encerrado: no tiene navegación y esa
         * pantalla ofrece volver a home, que tampoco puede abrir. Se lo devuelve a
         * lo único suyo. Si ya venía de ahí, se deja pasar el flujo normal para no
         * armar un bucle de redirecciones.
         */
    const guestPath = guestHomePath()

    if (guestPath && to.path !== guestPath) return next(guestPath)

    // If logged in => not authorized
    return next({ name: "misc-not-authorized" })
  }

  // Redirect if logged in
  if (to.meta.redirectIfLoggedIn && isLoggedIn) {
    const userData = getUserData()
    next(getHomeRouteForLoggedInUser(userData ? userData.role : null))
  }

  return next()
})

export default router
